export default { 
      img_folder:
    "/static/"
//      "http://flashteam.ru/images/"; 
 };


// WEBPACK FOOTER //
// ./src/utils/mysettings.js